document.addEventListener('DOMContentLoaded', function() {
    console.log('heheh');
    // Use event delegation
    document.body.addEventListener('click', function(event) {
        if (event.target.classList.contains('ajax-add-to-cart12')) {
            console.log('ok');
            var variantId = event.target.getAttribute('data-variant-id');
             var myprop = $('.myprop').val();
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1,
                        properties: {
                        "Ship Date": myprop
                        }
                    }]
                })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log('Item added to cart:', data);
                $('.mycart img').trigger('click');
            })
            .catch((error) => {
                console.error('Error adding to cart:', error);
            });
        }
    });
});